import React, { FC } from 'react'
import { Col, Container, Row, useScreenClass } from 'react-grid-system'
import { SectionTitle, ImageBlock, Button } from '../shared'
import styled from 'styled-components'
import MMAL from '../../assets/shows/MMAL.jpg'
import AllAmericanRuins from '../../assets/shows/AllAmericanRuins.jpg'
import SPESHFX from '../../assets/shows/SpeshFX.jpg'
import INTHY from '../../assets/shows/INTHY.jpg'

const Shows: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  const Section = styled.section`
    background-color: #002244;
    height: ${isDesktop ? '700px' : 'auto'};
    width: 100%;
    padding-top: ${isDesktop ? '20rem' : '2rem'};
    margin-top: ${isDesktop ? '-285px' : 'auto'};
    padding-bottom: 4rem;
  `

  // Now an <a> instead of a <div>, so only one navigation event
  const ClickableImageBlock = styled.a`
    display: block;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    text-decoration: none; /* remove default underline */

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    }
  `

  const imgStyles = {
    width: isDesktop ? undefined : '100%',
    margin: isDesktop ? undefined : '0 auto',
    display: 'block',
  }

  const shows = [
    {
      src: AllAmericanRuins,
      alt: 'All American Ruins Podcast Cover',
      link: 'https://www.blakepfeil.com/allamericanruins.html',
    },
    {
      src: MMAL,
      alt: 'My Most Authentic Life Podcast Cover',
      link: 'https://www.mymostauthenticlife.com/home',
    },
    {
      src: SPESHFX,
      alt: 'SpeshFX Podcast Cover',
      link: 'https://cms.megaphone.fm/channel/speshfx?selected=STONY7817442896',
    },
    {
      src: INTHY,
      alt: 'It’s Nice to Hear You Podcast Cover',
      link: 'https://www.itsnicetohearyou.com/',
    },
  ]

  return (
    <Section>
      <SectionTitle descr="Check out the shows that have been produced through our fellowship">
        Alumni Shows
      </SectionTitle>

      <Container style={{ marginTop: '4rem' }}>
        <Row>
          {shows.map(({ src, alt, link }, idx) => (
            <Col key={idx} xs={12} sm={12} md={6} lg={3}>
              <ClickableImageBlock
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageBlock
                  src={src}
                  alt={alt}
                  imgStyles={imgStyles}
                  // removed the `link` prop here so it doesn’t add its own <a>
                />
              </ClickableImageBlock>
            </Col>
          ))}
        </Row>

        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <Button variant="red" path="/shows">
            More Shows
          </Button>
        </div>
      </Container>
    </Section>
  )
}

export default Shows
